import { Customizer, initializeIcons, ITheme } from 'office-ui-fabric-react';
import * as React from 'react';
import { Provider } from 'react-redux';

import { ErrorFallback } from '../common/errorFallback';
import { createNameSpacedStore } from '../rootReducer';
import { defaultLightTheme } from '../theme';
import { ICommunicationEvents, IComponentProps, IRuntimeStaticConfig } from '../types';
import { uuidOptions } from '../utils';

import { IntentGraphBase } from './intentGraph.base';
import { loadResources } from './constants/stringLoader';

interface IState {
  theme: ITheme;
}

type IIntentGraphProps = IComponentProps;

const uuidv4 = require('uuid/v4');

export class IntentGraphC extends React.Component<IIntentGraphProps, IState> {
  private rootStore: any = null;
  public constructor(props: IIntentGraphProps) {
    super(props);
    
    this.state = {
      theme: this.props.staticConfig.theme || defaultLightTheme()
    };
    loadResources(this.props.staticConfig.localizedResources)
  }

  public componentDidMount(): void {
    initializeIcons();
    const communicationEvents: ICommunicationEvents = {
      onThemeChanged: this._changeTheme
    };
    if(!window.yoda){
      window.yoda = { IntentGraph: { Events: communicationEvents } };
    }
  }

  public componentWillUnmount(): void {
    window.yoda = null;
  }

  public render(): React.ReactNode | null {
    /**
     * We need to pass correlationId in order to prevent redux forcing stale state render.
     * Inside IntentGraphBase we check if the correlationId is the latest before we render children
     * this is an issue witnessed when IntentGraph is mounted again. Eg: new SupportCentral search wiping out previous intent graph
     */
    if(!this.rootStore){
      const namespace = this.props.staticConfig.namespace || 'singleton'
      this.rootStore =  createNameSpacedStore(namespace).rootStore;
      if(this.props.staticConfig.debugRootStore){
        window.rootStore = this.rootStore
      }
    }
    const staticConfig: IRuntimeStaticConfig = {
      ...this.props.staticConfig,
      correlationId: this.props.staticConfig.correlationId || uuidv4(uuidOptions())
    };
    return (
      <Provider store={this.rootStore}>
        <Customizer
          settings={{
            theme: this.state.theme
          }}
        >
          <ErrorFallback
            fallbackUi={this.props.staticConfig.errorUI || <></>}
            staticConfig={staticConfig}
            callbackHandlers={this.props.callbackHandlers}
            sessionId={this.props.staticConfig.sessionId}
          >
            <IntentGraphBase staticConfig={staticConfig} callbackHandlers={this.props.callbackHandlers} />
          </ErrorFallback>
        </Customizer>
      </Provider>
    );
  }

  private _changeTheme = (theme: ITheme): void => {
    if (theme) {
      // add log
      // tslint:disable-next-line: ban
      this.setState({
        theme: theme
      });
    }
  };
}

export const IntentGraph = IntentGraphC;
